

import React, { useState,useEffect } from "react";
import '../Home_css/Pts_xm.css';
import checkicon from '../../Assets/Dahlia_images/Icons__Pink_Checkmark_Icon.png';
import PainPTXImage from "../../Assets/Dahlia_images/ptx/pain_ptx.webp";
import Weightloss from "../../Assets/Dahlia_images/ptx/weightloss_ptx.webp";
import Circulationptx from "../../Assets/Dahlia_images/ptx/circulation_ptx.webp";
import Skinptx from "../../Assets/Dahlia_images/ptx/skin_ptx.webp";
import Recoverptx from "../../Assets/Dahlia_images/ptx/recovery_ptx.webp";
import { Container } from "react-bootstrap";
import Pain_pdf from "../../Assets/PTx-Download_PDFs/DH_PainPTx.pdf";
import Wightloss_pdf from "../../Assets/PTx-Download_PDFs/DH_WeightLossPTx.pdf";
import Circulation_pdf from "../../Assets/PTx-Download_PDFs/DH_CirculationPTx.pdf";
import Skin_pdf from "../../Assets/PTx-Download_PDFs/DH_SkinPTx.pdf";
import Rocover_pdf from "../../Assets/PTx-Download_PDFs/DH_RecoveryPTx.pdf";



const OverPTS = () => {
  const [activeTab, setActiveTab] = useState("PainPTX");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty dependency array to run once when the component mounts

  const tabData = {
    PainPTX: {
      title: "PAIN BENEFITS",
      description: "Our Pain PTx™ offers a range of benefits for individuals seeking effective pain management:",
      image: PainPTXImage,
      pdf: Pain_pdf,
      benefits: [
        {
          title: "SUPPORTS PAIN REDUCTION",
          text: `Light therapy effectively reduces pain by targeting swelling and promoting the release of endorphins, the body’s natural painkillers <sup>(1)(2)(3)(4)(5)(6)(7)(8)(9)(10)(11)(12)(13)(25)</sup>`
        },
        {
          title: "SUPPORTS FASTER RECOVERY",
          text: `Light therapy accelerates the healing process by promoting cellular repair and regeneration, helping you recover more quickly from injuries and strains <sup class="sup">(18)(26)</sup>`
        },
        {
          title: "SUPPORTS REDUCED SWELLING",
          text: `Our Pain PTx™ helps to aid in reducing swelling, which is often the underlying cause of chronic pain <sup class="sup">(3)(25)</sup>`
        },
        {
          title: "NON-INVASIVE AND SAFE",
          text: `Our light therapy offers a non-invasive alternative to traditional pain management methods, with no downtime or significant side effects <sup class="sup">(25)</sup>`
        }
      ]
    },
  
    WeightLossPTX: {
      title: "WEIGHT LOSS BENEFITS",
      description: "Our Weight Loss PTx™ offers a range of benefits for individuals seeking to enhance their weight loss efforts:",
      image: Weightloss,
      pdf: Wightloss_pdf,
      benefits: [
        {
          title: "SUPPORTS FAT REDUCTION",
          text: `Light therapy aids in the breakdown of fat cells, facilitating their removal from the body and supporting overall weight loss goals <sup class="sup">(1)(2)(4)(5)(6)(7)(8)</sup>`
        },
        {
          title: "SUPPORTS ENHANCED METABOLISM",
          text: `By stimulating cellular activity, our PTx™ enhances metabolic functions, helping your body burn calories more efficiently <sup class="sup">(1)</sup>`
        },
        {
          title: "SUPPORTS IMPROVED ENERGY LEVELS",
          text: `The increase in ATP production boosts your energy levels, enabling you to stay active and motivated throughout your weight loss journey <sup class="sup">(6)</sup>`
        },
        {
          title: "SUPPORTS REDUCED SWELLING",
          text: "Light therapy reduces swelling, which is often linked to weight gain and metabolic issues."
        },
        {
          title: "POSITIVELY STIMULATES HORMONES",
          text: `Directly impacts Leptin and Ghrelin hormones to help aid fat burning and satiation <sup class="sup">(3)</sup>`
        },
        {
          title: "NON-INVASIVE AND SAFE",
          text: "Our Weight Loss PTx™ offers a non-invasive alternative to traditional weight loss methods, with no downtime or significant side effects."
        }
      ]
    },
  
    CirculationPTX: {
      title: "CIRCULATION BENEFITS",
      description: "Our Circulation PTx™ offers a range of benefits for individuals seeking to improve their circulatory health:",
      image: Circulationptx,
      pdf: Circulation_pdf,
      benefits: [
        {
          title: "SUPPORTS ENHANCED BLOOD FLOW",
          text: `Light therapy stimulates vasodilation, improving blood flow and ensuring that oxygen and nutrients reach all parts of the body more efficiently <sup class="sup">(1)(2)(3)(4)</sup>`
        },
        {
          title: "SUPPORTS IMPROVED VASCULAR FUNCTION",
          text: `By promoting the production of nitric oxide, our protocol supports healthy blood vessel function and reduces the risk of vascular issues <sup class="sup">(2)</sup>`
        },
        {
          title: "SUPPORTS REDUCED SWELLING",
          text: `Light therapy helps to reduce inflammation and swelling, often associated with poor circulation, providing relief and improving comfort <sup class="sup">(5)</sup>`
        },
        {
          title: "SUPPORTS ACCELERATED HEALING",
          text: `Enhanced circulation aids in faster recovery and healing by delivering essential nutrients and oxygen to damaged tissues <sup class="sup">(1)</sup>`
        },
        {
          title: "NON-INVASIVE AND SAFE",
          text: "Our light therapy protocol offers a non-invasive alternative to traditional treatments, with no downtime or significant side effects."
        }
      ]
    },
  
    SkinPTX: {
      title: "SKIN BENEFITS",
      description: "Our Skin PTx™ offers a range of benefits for individuals seeking to enhance their skin health and combat aging:",
      image: Skinptx,
      pdf: Skin_pdf,
      benefits: [
        {
          title: "SUPPORTS INCREASED CELLULAR ENERGY & TISSUE OXYGENATION",
          text: `Mitochondria are the “power plants” of human cells, capable of using both chemical energy (glucose) and light energy to produce energy known as “ATP”. Additional cellular energy within skin cells enables healthier skin <sup class="sup">(1)(3)</sup>`
        },
        {
          title: "SUPPORTS INCREASED COLLAGEN PRODUCTION",
          text: `Light therapy stimulates collagen production, helping to restore skin elasticity and firmness <sup class="sup">(2)(3)(8)</sup>`
        },
        {
          title: "SUPPORTS REDUCED WRINKLES AND FINE LINES",
          text: `Regular use of our treatment can significantly reduce the appearance of wrinkles and fine lines, promoting a smoother, more youthful complexion <sup class="sup">(2)</sup>`
        },
        {
          title: "NON-INVASIVE AND SAFE",
          text: `Our light therapy PTx™ offers a non-invasive alternative to traditional anti-aging treatments, with no downtime or significant side effects <sup class="sup">(6)</sup>`
        },
        {
          title: "SUPPORTS SCAR REDUCTION",
          text: `Light therapy mechanisms involved are inhibition of TGF-beta I expression <sup class="sup">(9)</sup>`
        },
        {
          title: "SUPPORTS IMPROVED SKIN TONE AND TEXTURE",
          text: `Light therapy enhances cellular turnover, resulting in improved skin texture and a more even skin tone <sup class="sup">(2)(8)</sup>`
        }
      ]
    },
  
    RecoveryPTX: {
      title: "RECOVERY BENEFITS",
      description: "Our Recovery PTx™ offers a range of benefits for individuals seeking to enhance their muscle health and athletic performance:",
      image: Recoverptx,
      pdf: Rocover_pdf,
      benefits: [
        {
          title: "SUPPORTS INCREASED CELLULAR ENERGY & TISSUE OXYGENATION",
          text: `Mitochondria are the 'power plants' of human cells, capable of using both chemical energy (glucose) and light energy to produce energy known as “ATP”. Additional cellular energy within skin cells enables healthier tissue <sup class="sup">(1)(3)</sup>`
        },
        {
          title: "SUPPORTS INCREASED COLLAGEN PRODUCTION",
          text: `Light therapy stimulates collagen production, helping to restore tissue elasticity and firmness <sup class="sup">(2)(3)(8)</sup>`
        },
        {
          title: "SUPPORTS REDUCED WRINKLES AND FINE LINES",
          text: `Regular use of our treatment can significantly reduce the appearance of wrinkles and fine lines, promoting a smoother, more youthful look <sup class="sup">(2)</sup>`
        },
        {
          title: "NON-INVASIVE AND SAFE",
          text: `Our light therapy PTx™ offers a non-invasive alternative to traditional treatments, with no downtime or significant side effects <sup class="sup">(6)</sup>`
        },
        {
          title: "SUPPORTS SCAR REDUCTION",
          text: `Light therapy mechanisms involved are inhibition of TGF-beta I expression <sup class="sup">(9)</sup>`
        },
        {
          title: "SUPPORTS IMPROVED SKIN TONE AND TEXTURE",
          text: `Light therapy enhances cellular turnover, resulting in improved skin texture and a more even skin tone <sup class="sup">(2)(8)</sup>`
        }
      ]
    }
  };
  
  
  
  const handlePDFDownload = () => {
    if (!tabData || !tabData[activeTab] || !tabData[activeTab].pdf) {
      console.error("No PDF data available for this tab.");
      alert("Sorry, there's no PDF available for this tab."); // Or a better user notification
      return;}
    const link = document.createElement("a");
    link.href = tabData[activeTab].pdf; // Use the PDF file based on active tab
    link.download = tabData[activeTab].pdf;
    link.click();
      };
      
  return (
   
    <section id="Treatments">
      <div>
    <Container >
  
      <div className="mainContainer">
        <div className="heading-container">
          <div className="heading">
            Discover Our <span className="highlight">PrescriptiveTreatments™</span>
          </div>
        </div>

        <div className="content-container">
          {/* Navigation Tabs (Only switch tabs on mobile) */}
          <div className="tab-nav d-flex">
            {Object.keys(tabData).map((tab) => (
              <button
                key={tab}
                className={`tab-btn ${activeTab === tab ? "active" : ""}`}
                onClick={() => setActiveTab(tab)}
                // onClick={() => (isMobile ? setActiveTab(tab) : null)}
              >
                {tab.replace("PTX", " PTx™")}
              </button>
            ))}
          </div>

       
       
          <div className="tab_content_containerx">
  {Object.entries(tabData).map(([key, data]) => (
    <div
      key={key}
      className={`tab-content-wrapper ${activeTab === key ? 'active' : 'hidden'}`}
    >
      <div className="custom_row">
        <div className="col-12 col-md-4 d-flex align-items-stretch">
          <div className="tab_image">
            <div
              className="therapy-image"
              style={{
                backgroundImage: `url(${data.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                height: "100%",
              }}
            ></div>
          </div>
        </div>

        <div className="col-12 col-md-8 d-flex align-items-stretch">
          <div className="tab_content">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <p className="main-heading">
                  <span className="light-therapy">Light Therapy</span> <br />
                  <span className="pain-benefits">{data.title}</span>
                </p>
              </div>
              <button className="download-btn" onClick={() => {
                if (data.pdf) {
                  const link = document.createElement("a");
                  link.href = data.pdf;
                  link.download = data.pdf;
                  link.click();
                } else {
                  alert("No PDF available for this tab.");
                }
              }}>Download PDF</button>
            </div>

            <p className="tab-description">{data.description}</p>

            <div className="benefits-grid">
              {data.benefits.map((benefit, index) => (
                <div key={index} className="benefit">
                  <img src={checkicon} className="tab_check" alt="Check icon" />
                  <div className="landingInfo">
                    <div className="benefit-card">
                      <h4>{benefit.title}</h4>
                      <p className="tab-description" dangerouslySetInnerHTML={{ __html: benefit.text }} />
                    </div>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </div>
  ))}
</div>

       
        




          <div className="clearfix"></div>
        </div>
      </div>
      </Container>
      </div>
      </section>
  );
};

export default OverPTS;
